"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const Checkbox_1 = tslib_1.__importDefault(require("../checkbox/Checkbox"));
const TreeNode = react_1.default.memo(props => {
    const { node, hasMultiselect, isSelected, isIndeterminate, onToggleNode, onSelect } = props;
    const treeNodeClassNames = (0, classnames_1.default)('TreeNode', 'from-group', isSelected && 'checked', node.className && node.className);
    const hasChildren = !!node.items.length;
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: treeNodeClassNames, "data-key": node.id, onClick: () => hasChildren && onToggleNode(node.id) }, { children: [hasMultiselect && ((0, jsx_runtime_1.jsx)(Checkbox_1.default, { className: 'TreeCheckbox', checked: isSelected, disabled: node.disabled, indeterminate: isIndeterminate, onClick: () => onSelect(node, isIndeterminate) })), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: 'TreeLabel' }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ className: 'TreeLabelName' }, { children: [node.icon && (0, jsx_runtime_1.jsx)("span", { className: `rioglyph ${node.icon}` }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'TreeLabelNameText' }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'TreeLabelNameTextHeadline' }, { children: node.name })) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'TreeLabelCount label label-muted label-filled label-condensed' }, { children: node.items.length }))] })), (0, jsx_runtime_1.jsx)("span", { className: `TreeLabelExpander rioglyph rioglyph-chevron-down ${hasChildren ? '' : 'text-color-light'}` })] }))] })));
});
TreeNode.displayName = 'TreeNode';
TreeNode.defaultProps = {
    isSelected: false,
    isIndeterminate: false,
    hasMultiselect: true,
};
TreeNode.propTypes = {
    node: prop_types_1.default.object,
    hasMultiselect: prop_types_1.default.bool,
    isSelected: prop_types_1.default.bool,
    isIndeterminate: prop_types_1.default.bool,
    onToggleNode: prop_types_1.default.func,
    onSelect: prop_types_1.default.func,
    className: prop_types_1.default.string,
};
exports.default = TreeNode;
